import { useContext, useMemo } from 'react'
import { useQuery } from 'react-query'
import { apiGet, apiPostQuery, estimateQueryStringLength } from 'api'
import AuthContext from 'context/auth-context'

// Puma's default query string limit is 10KB; use POST well before that
const MAX_GET_QUERY_LENGTH = 8000

const getDashboardChartData = async (token, dashboardId, chartId, params) => {
  if (estimateQueryStringLength(params) > MAX_GET_QUERY_LENGTH) {
    return apiPostQuery({ url: `charts/${chartId}/data/query`, token, params })
  }

  const url = `charts/${chartId}/data`

  const data = await apiGet({ url, token, params })
  return data
}

export default function useCharts({ dashboardId, chartId, params, options }) {
  const token = useContext(AuthContext)
  
  // Create a stable query key by stringifying params
  // This ensures that the query only refetches when params actually change
  const stableParamsKey = useMemo(() => {
    return JSON.stringify(params || {})
  }, [params])
  
  const queryKey = ['dashboard-chart-data', dashboardId, chartId, stableParamsKey]
  const queryFn = () =>
    getDashboardChartData(token, dashboardId, chartId, params)

  return useQuery(queryKey, queryFn, {
    ...options
  })
}
